export const GET_ALL_JOB_CARDS = 'GET_ALL_JOB_CARDS';
export const GET_ALL_JOB_CARDS_FAILED = 'GET_ALL_JOB_CARDS_FAILED';
export const REMOVE_JOBCARD_BY_ID = 'REMOVE_JOBCARD_BY_ID';
export const UPDATE_ENABLE_FOR_JOBCARD_BY_ID = 'UPDATE_ENABLE_FOR_JOBCARD_BY_ID';
export const LOAD_ALL_COLORS_OF_JOBCARDS = 'LOAD_ALL_COLORS_OF_JOBCARDS';
export const LOAD_JOBCARD_BY_ID = 'LOAD_JOBCARD_BY_ID';
export const ADD_NEW_JOBCARD = 'ADD_NEW_JOBCARD';
export const UPDATE_JOBCARD_BY_ID = 'UPDATE_JOBCARD_BY_ID';

export function getAllJobCards(data) {
  return {
    type: GET_ALL_JOB_CARDS,
    payload: data,
  }
}

export function removeJobCardById(data) {
  return {
    type: REMOVE_JOBCARD_BY_ID,
    payload: data,
  }
}

export function updateEnableForJobCardById(data) {
    return {
      type: UPDATE_ENABLE_FOR_JOBCARD_BY_ID,
      payload: data,
    }
}

export function loadAllColorsOfJobCards(data) {
    return {
      type: LOAD_ALL_COLORS_OF_JOBCARDS,
      payload: data,
    }
}

export function loadJobCardById(data) {
    return {
      type: LOAD_JOBCARD_BY_ID,
      payload: data,
    }
}

export function addNewJobCard(data) {
    return {
      type: ADD_NEW_JOBCARD,
      payload: data,
    }
}

export function updateJobCardById(data) {
    return {
      type: UPDATE_JOBCARD_BY_ID,
      payload: data,
    }
}

export function getAllJobCardsFailed(data) {
  return {
    type: GET_ALL_JOB_CARDS,
    payload: data,
  }
}



// WEBPACK FOOTER //
// ./src/actions/jobCards/index.js